export class Fabrictype {
    id: string = '';
    name: string = '';
    active: boolean;
    default: boolean;
    unit_type: string;
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/fabrictypes/fabrictype.ts